import { convertPriceToInt } from 'Utils/helper';
import { leoCapture, isSameLeoAnonymousUser } from 'Service/LeoService';

const toBoolean = value => value === true || value === 'true';

const withAdsAttributionFields = (payload, item, anonymousId) => {
  if (!isSameLeoAnonymousUser(anonymousId ?? item?.anonymousId)) {
    return payload;
  }

  return {
    ...payload,
    is_promoted: toBoolean(item?.isPromoted),
    ads_unique_id: item?.adsUniqueId || ''
  };
};

export const buildAddToFavoritesLeoPayload = (item, anonymousId) => {
  const payload = {
    placement_id: item?.placementId || '',
    placement_title: item?.placementTitle || '',
    location: item?.location || '',
    product_id: item?.productId || '',
    product_name: item?.productName || item?.name || '',
    brand: item?.brand || '',
    sku: item?.sku || '',
    listing_id: item?.listingId || '',
    position: Number(item?.position) || 1,
    price: convertPriceToInt(item?.price) || null,
    base_price: item?.basePrice != null ? convertPriceToInt(item.basePrice) || null : null,
    merchant_id: item?.merchantId || '',
    campaign_id: item?.campaignId || '',
    ads_supplier_id: item?.adsSupplierId || '',
    ad_show_id: item?.adShowId || ''
  };

  return withAdsAttributionFields(payload, item, anonymousId);
};

export const buildAddToMyListLeoPayload = (item, anonymousId) => {
  const payload = {
    ads_supplier_id: item?.adsSupplierId || '',
    campaign_id: item?.campaignId || '',
    product_id: item?.productId || '',
    product_name: item?.productName || item?.name || '',
    position: Number(item?.position) || 1,
    brand: item?.brand || '',
    category_string: item?.categoryNameHierarchy || item?.categoryName || item?.category_string || '',
    category_id: String(item?.categoryId ?? ''),
    ads_campaign_owner_type: item?.adsCampaignOwnerType || '',
    page_value: item?.pageValue || item?.sku || '',
    sku: item?.sku || ''
  };

  return withAdsAttributionFields(payload, item, anonymousId);
};

export const addToFavoritesLeoEvent = (item, anonymousId) => {
  leoCapture('add_to_favorites', 'click', buildAddToFavoritesLeoPayload(item, anonymousId));
};

export const addToMyListLeoEvent = (item, anonymousId) => {
  leoCapture('add_to_my_list', 'click', buildAddToMyListLeoPayload(item, anonymousId));
};
